module.exports = __webpack_public_path__ + "static/media/arrow-right-orange.8b08fdff.svg";